import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    options: Object,
  }

  connect() {
    $(this.element).select2(this.fullOptions())
  }

  disconnect() {
    $(this.element).select2('destroy')
  }

  fullOptions() {
    let defaultOptions = {
      width: 'resolve'
    }
    return Object.assign(defaultOptions, this.optionsValue)
  }
}
